import api from '@/api'
import { login } from '@/api/base'
import { getUserPermission } from '@/api/permission'

// 获取当前可用的权限
function getAllActivePermissions(menuData) {
    let permissions = []
    function traverse(items) {
        for (const item of items) {
            if (item.status === 1) {
                if (item.permission) {
                    permissions.push(item.permission)
                }
                // 递归处理子节点
                if (item.children && item.children.length > 0) {
                    traverse(item.children)
                }
            }
        }
    }
    traverse(menuData)
    return permissions
}

const state = () => ({
    account: localStorage.account || '',
    token: localStorage.token || '665544',
    failure_time: localStorage.failure_time || '',
    permissions: [], // 权限
    permissionsLoaded: false,
    roleType: '' // 角色类型
})

const getters = {
    isLogin: state => {
        let retn = false
        if (state.token) {
            if (new Date().getTime() < state.failure_time * 1000) {
                retn = true
            }
        }
        return retn
    },
    // 是否为超级管理员
    isSupOperate: state => {
        return state.roleType === 1
    }
}

const actions = {
    async login({ commit, dispatch }, data) {
        // 2026-03-18 phone 改为 username
        const res = await login({ username: data.account, password: data.password })
        const { phone, username } = res.data.user_info
        commit('menu/invalidRoutes', null, { root: true })
        commit('menu/removeRoutes', null, { root: true })
        commit('setPermissions', [])
        commit('setPermissionsLoaded', false)
        commit('setRoleType', '')
        commit('setUserData', {
            phone,
            account: username,
            token: `${res.data.authorize.type} ${res.data.authorize.access_token}`,
            failure_time: Math.ceil(new Date().getTime() / 1000) + 24 * 60 * 60 * 3 // 三天过期时间
        })
        try {
            await dispatch('getPermissions')
        } catch (error) {
            await dispatch('logout')
            throw error
        }
    },
    logout({ commit }) {
        commit('removeUserData')
        commit('setPermissions', [])
        commit('setPermissionsLoaded', false)
        commit('setRoleType', '')
        commit('menu/invalidRoutes', null, { root: true })
        commit('menu/removeRoutes', null, { root: true })
    },
    // 获取我的权限
    async getPermissions({ commit, state }) {
        if (!state.permissionsLoaded) {
            const res = await getUserPermission()
            commit('setPermissions', res.data.menus)
            commit('setRoleType', res.data.role_type)
            commit('setPermissionsLoaded', true)
        }
        return state.permissions
    },
    editPassword({ state }, data) {
        return new Promise(resolve => {
            api.post('member/edit/password', {
                account: state.account,
                password: data.password,
                newpassword: data.newpassword
            }, {
                baseURL: '/mock/'
            }).then(() => {
                resolve()
            })
        })
    }
}

const mutations = {
    setUserData(state, data) {
        localStorage.setItem('account', data.account)
        localStorage.setItem('token', data.token)
        localStorage.setItem('failure_time', data.failure_time)
        state.account = data.account
        state.token = data.token
        state.failure_time = data.failure_time
    },
    removeUserData(state) {
        localStorage.removeItem('account')
        localStorage.removeItem('token')
        localStorage.removeItem('failure_time')
        state.account = ''
        state.token = ''
        state.failure_time = ''
    },
    setPermissions(state, permissions = []) {
        const activePermissions = getAllActivePermissions(permissions)
        state.permissions = activePermissions
    },
    setPermissionsLoaded(state, loaded) {
        state.permissionsLoaded = loaded
    },
    setRoleType(state, val) {
        state.roleType = val
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
